import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "space-y-4 p-4 sm:p-6 lg:p-8"
}
const _hoisted_2 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "flex items-center space-x-4" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-4 md:grid-cols-4" }
const _hoisted_5 = { class: "mb-1 font-semibold" }
const _hoisted_6 = { class: "mb-1 font-semibold" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "mb-1 font-semibold" }
const _hoisted_10 = { class: "mb-1 font-semibold" }
const _hoisted_11 = { class: "mb-1 font-semibold" }
const _hoisted_12 = { class: "mb-1 font-semibold" }

import { ref, Ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import { useUiStore } from '@/stores';
import NumberService from '@/services/api/NumberService';
import { toastServiceError } from '@/services/core/notification';
import { Permission, NumberModel } from '@/types';
import { applyPhoneMask } from '@/utils/number';


export default /*@__PURE__*/_defineComponent({
  __name: 'NumberDetailPage',
  setup(__props) {

const number: Ref<NumberModel | undefined> = ref(undefined);

const route = useRoute();
const uiStore = useUiStore();

const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const fetchNumber = async (id: number) => {
    try {
        setLoading(true);
        const response = await NumberService.get<NumberModel>(id);
        number.value = response.data;
    } catch (error) {
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

onMounted(() => {
    const id = Number(route.params.id);
    if (!isNaN(id)) {
        fetchNumber(id);
    }
});

return (_ctx: any,_cache: any) => {
  const _component_UiBackButton = _resolveComponent("UiBackButton")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiAuditStatusInfo = _resolveComponent("UiAuditStatusInfo")!
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (number.value !== undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_UiPageHeader, null, {
          info: _withCtx(() => [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('number.view.section.number.title')), 1)
          ]),
          actions: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_UiBackButton, { fallbackTo: { name: 'ListNumber' } }),
              (_ctx.$can(_unref(Permission).EDIT_USER))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {
                            name: 'EditNumberById',
                            params: {
                                id: number.value?.id,
                            },
                        },
                    class: "block hover:bg-gray-50"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UiButton, {
                        variant: "primary",
                        "text-variant": "white"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Edit')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_UiPanel, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('core.entity.Level')), 1),
                _createElementVNode("p", null, _toDisplayString(number.value?.level.name), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('number.labels.number')), 1),
                (number.value.number)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(applyPhoneMask)(number.value.number)), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_8, "-"))
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t('number.labels.city')), 1),
                _createElementVNode("p", null, _toDisplayString(number.value?.city) + "/" + _toDisplayString(number.value?.state), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t('number.labels.type')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t(`number.types.${number.value?.type}`)), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t('core.entity.ConnectFlow')), 1),
                _createElementVNode("p", null, _toDisplayString(number.value?.connectFlow?.name), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t('number.labels.mediaLabel')), 1),
                _createElementVNode("p", null, _toDisplayString(number.value.mediaLabel), 1)
              ])
            ]),
            _createVNode(_component_UiAuditStatusInfo, {
              "model-value": number.value,
              class: "bt-1 mt-4 border-t border-gray-300 pt-2"
            }, null, 8, ["model-value"])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})